import React, { useCallback, useEffect, useRef, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import {
  Table,
  Pagination,
  RowsPerPageSelect,
} from "../../../components/Table";
import { useQuery } from "@apollo/client";
import { GET_MERCHANT_VENDOR_SETTLEMENT_REPORT } from "../../../Qurries";
import { amountFormat } from "../../../utils/amountFormat";
import { getStartAndEndOfMonth } from "../../../utils/getStartDateAndEndDate";
import TransactionDateFilter, {
  formatDate,
} from "../Transaction/components/TransactionDateFilter";
import { HiMiniXMark } from "react-icons/hi2";
import { endOfDay, startOfDay } from "date-fns";

import { CustomDropdownIndicator } from "../Settlement/Settlement";
import Select from "react-select";
import { IoSearchOutline } from "react-icons/io5";
import VendorDropdownSelect, { VendorOption } from "../Transaction/components/AllFilter/VendorDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { usePaymentUrlFilters } from "../../../hooks/usePaymentUrlFilters";
import { parseDateParam } from "../../../utils/paymentUrlFilters";

function VendorSettlement() {
  const { get, getNumber, getBoolean, updateParams } = usePaymentUrlFilters();
  const location = useLocation();
  const skipUrlSyncRef = useRef(true);
  const settlementReturnPath = `${location.pathname}${location.search}`;
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState<any>(() => get("search"));
  const [currentPage, setCurrentPage] = useState(() => getNumber("page", 1));
  const [itemsPerRow, setItemsPerRow] = useState({
    name: getNumber("limit", 10),
  });
  const urlStartDate = parseDateParam(get("start_date"));
  const urlEndDate = parseDateParam(get("end_date"));
  const [selectedRange, setSelectedRange] = useState({
    startDate: urlStartDate || new Date(),
    endDate: urlEndDate || new Date(),
    key: "selection",
  });

  const [type, setType] = useState(() => get("date_range"));

  const [totalPages, setTotalPages] = useState<number>(1);
  const [dateRange, setDateRange] = useState(() => get("date_range"));
  const [settlementData, setSettlementData] = useState<any>([]);
  const [isDateRangeIsSelected, setIsDateRangeIsSelected] = useState(() =>
    getBoolean("custom_date"),
  );
  const [status, setStatus] = useState<any>(() => get("status") || null);
  const [, setSchoolId] = useState<string>("");
  const [selectSchool, setSelectSchool] = useState(() => get("vendor_name") || "");
  const [refetching, setRefetching] = useState(false);
  const { startDate, endDate } = getStartAndEndOfMonth();
  const [selectedVendorOption, setSelectedVendorOption] =
    useState<VendorOption | null>(() => {
      const vendorId = get("vendor_id");
      const vendorName = get("vendor_name");

      return vendorId
        ? {
          id: vendorId,
          label: vendorName,
          value: vendorName,
        }
        : null;
    });
  const [searchFilter, setSearchFilter] = useState<any>(() =>
    get("search_filter"),
  );
  const { data, loading, refetch } = useQuery(
    GET_MERCHANT_VENDOR_SETTLEMENT_REPORT,
    {
      variables: {
        page: currentPage,
        limit: itemsPerRow.name,
        start_date: startDate,
        end_date: endDate,
        utr: searchFilter === "utr" ? searchText : null,
        vendor_id: searchFilter === "vendor_id" ? searchText : null
      },
    }
  );

  useEffect(() => {
    if (data?.getMerchantVendorSettlementReport?.vendor_settlements) {
      setSettlementData(data.getMerchantVendorSettlementReport.vendor_settlements);
      setTotalPages(data.getMerchantVendorSettlementReport.totalPages ?? 1);
    }
  }, [data]);

  useEffect(() => {
    skipUrlSyncRef.current = false;
  }, []);

  useEffect(() => {
    if (skipUrlSyncRef.current) return;

    updateParams({
      page: currentPage > 1 ? currentPage : null,
      limit: itemsPerRow.name !== 10 ? itemsPerRow.name : null,
      search: searchText || null,
      search_filter: searchFilter || null,
      status: status || null,
      start_date: isDateRangeIsSelected
        ? formatDate(selectedRange.startDate)
        : null,
      end_date: isDateRangeIsSelected
        ? formatDate(selectedRange.endDate)
        : null,
      vendor_id: selectedVendorOption?.id ?? null,
      vendor_name: selectedVendorOption?.label ?? null,

      custom_date: isDateRangeIsSelected ? true : null,
      date_range: dateRange || null,
    });
  }, [
    currentPage,
    itemsPerRow.name,
    searchText,
    searchFilter,
    status,
    isDateRangeIsSelected,
    selectedRange.startDate,
    selectedRange.endDate,
    dateRange,
    type,
    updateParams,
    selectedVendorOption,
  ]);

  const refetchDataFetch = useCallback(async ({
    start_date,
    end_date,
    page,
    limit,
    status,
    // school_id,
    vendor_id,
    utr,
  }: {
    start_date?: any;
    end_date?: any;
    page?: Number;
    status?: String;
    // school_id?: string | null;
    limit?: Number;
    vendor_id?: string;
    utr?: string;
  }) => {

    const pageToUse = page !== undefined ? page : currentPage;
    try {
      setRefetching(true);
      const data = await refetch({
        end_date,
        start_date,
        page: pageToUse,
        limit: limit || itemsPerRow.name,
        status,
        // school_id,
        vendor_id,
        utr,
      });
      if (data?.data?.getMerchantVendorSettlementReport?.vendor_settlements) {
        setRefetching(false);
        setSettlementData(
          data?.data?.getMerchantVendorSettlementReport?.vendor_settlements
        );
        setTotalPages(data.data.getMerchantVendorSettlementReport.totalPages ?? 1);
      }
    } catch (error) { }
  }, [currentPage, itemsPerRow.name, refetch]);

  // useEffect(() => {
  //   refetchDataFetch({
  //     start_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.startDate)
  //       : startDate,
  //     end_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.endDate)
  //       : endDate,
  //     status: status?.toUpperCase(),
  //     // school_id: schoolId === "" ? null : schoolId,
  //     vendor_id: schoolId === "" ? undefined : schoolId,
  //     utr: searchFilter === "utr" ? searchText : null,
  //   });
  // }, [itemsPerRow, currentPage, schoolId,endDate,isDateRangeIsSelected,refetchDataFetch, searchFilter, searchText, selectedRange.endDate, selectedRange.startDate, startDate,status]);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
    refetchDataFetch({
      page: page,
      limit: Number(itemsPerRow.name),
      start_date: isDateRangeIsSelected
        ? formatDate(selectedRange.startDate)
        : startDate,
      end_date: isDateRangeIsSelected
        ? formatDate(selectedRange.endDate)
        : endDate,
      status: status?.toUpperCase(),
      vendor_id: selectedVendorOption?.id ?? undefined,
    });
  };
  const handleVendorSelect = (vendor: VendorOption | null) => {
    if (vendor) {
      setSelectSchool(vendor.label);
      setSchoolId(vendor.id);
      setSelectedVendorOption(vendor);
    } else {
      setSelectSchool("");
      setSchoolId("");
      setSelectedVendorOption(null);
    }

    // Trigger refetch with the selected vendor
    setCurrentPage(1);
    refetchDataFetch({
      page: 1,
      limit: Number(itemsPerRow.name),
      start_date: isDateRangeIsSelected
        ? formatDate(selectedRange.startDate)
        : startDate,
      end_date: isDateRangeIsSelected
        ? formatDate(selectedRange.endDate)
        : endDate,
      status: status?.toUpperCase(),
      vendor_id: vendor?.id ?? undefined,
      utr: searchFilter === "utr" ? searchText : undefined,
    });
  };

  return (
    <div>

      <Table
        currentPage={currentPage}
        perPage={false}
        exportBtn={true}
        heading={"Settlements"}
        copyContent={[10]}
        filter={[searchText]}
        loading={loading || refetching}
        isCustomFilter={true}
        searchBox={
          <div className="w-full ">
            <div className="flex xl:!flex-row flex-col justify-between gap-2  w-full xl:items-center items-start mb-2">
              <div className="bg-[#EEF1F6] py-3 items-center flex  px-3 xl:max-w-md max-w-[34rem] w-full rounded-lg">
                <input
                  className="text-xs pr-2 bg-transparent focus:outline-none w-full placeholder:font-normal"
                  type="text"
                  value={searchText}
                  placeholder="Search(Order ID...)"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
                {searchFilter !== "" && searchText.length > 3 && (
                  <HiMiniXMark
                    onClick={async () => {
                      setSearchFilter("");
                      setSearchText("");
                      setCurrentPage(1);
                      refetchDataFetch({
                        page: 1,
                        limit: Number(itemsPerRow.name),
                        start_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.startDate)
                          : startDate,
                        end_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.endDate)
                          : endDate,
                        status: status?.toUpperCase(),
                        vendor_id:
                          searchFilter === "vendor_id"
                            ? searchText
                            : selectedVendorOption?.id ?? undefined,
                      });
                    }}
                    className="text-[#1E1B59] cursor-pointer text-md mr-2 shrink-0"
                  />
                )}
                <Select
                  className="border-l-2 border-gray-400"
                  options={[
                    {
                      label: "By UTR",
                      value: "utr",
                    },
                    { label: "By Vendor ID", value: "vendor_id" },
                  ]}
                  isSearchable={false}
                  components={{
                    DropdownIndicator: CustomDropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                  onChange={(e: any) => {
                    setSearchFilter(e.value.toLowerCase());
                    setCurrentPage(1);
                  }}
                  placeholder={
                    <div className="text-[#1E1B59] -mt-1 capitalize text-[10px]">
                      {searchFilter === ""
                        ? "filter by"
                        : searchFilter
                          .toString()
                          .toLowerCase()
                          .replaceAll("_", " ") === "utr"
                          ? "By UTR"
                          : searchFilter
                            .toString()
                            .toLowerCase()
                            .replaceAll("_", " ")}
                    </div>
                  }
                  value={searchFilter}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: "transparent",
                      height: "20px",
                      border: "none",
                      boxShadow: "none",
                      cursor: "pointer",
                      minHeight: "10px",
                      padding: "0px",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "20px",
                      width: "8rem",
                      padding: "0 8px",
                    }),
                    input: (provided) => ({
                      ...provided,
                      margin: "0",
                      padding: "0",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      margin: "0",
                      padding: "0",
                      lineHeight: "20px",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      lineHeight: "20px",
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: "20px",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: "10px",
                      cursor: "pointer",
                    }),
                  }}
                />

                <div className="w-10 z-50 shrink-0 flex justify-center items-center">
                  {searchText.length > 3 && refetching ? (
                    <AiOutlineLoading3Quarters className="text-xs animate-spin" />
                  ) : (
                    <IoSearchOutline
                      onClick={() => {
                        if (searchText.length > 3 && searchFilter !== "") {
                          setCurrentPage(1);
                          refetchDataFetch({
                            page: 1,
                            limit: Number(itemsPerRow.name),
                            start_date: isDateRangeIsSelected
                              ? formatDate(selectedRange.startDate)
                              : startDate,
                            end_date: isDateRangeIsSelected
                              ? formatDate(selectedRange.endDate)
                              : endDate,
                            status: status?.toUpperCase(),
                            vendor_id:
                              searchFilter === "vendor_id"
                                ? searchText
                                : null,
                            utr: searchFilter === "utr" ? searchText : null,
                          });
                        }
                      }}
                      className=" cursor-pointer text-edvion_black text-opacity-50 text-md "
                    />
                  )}
                </div>
              </div>

              <div className="flex justify-end items-center flex-1 w-full max-w-[26rem]">
                <TransactionDateFilter
                  setType={setDateRange}
                  type={dateRange}
                  refetch={() => {
                    setCurrentPage(1);
                    refetchDataFetch({
                      page: 1,
                      limit: Number(itemsPerRow.name),
                      start_date: formatDate(selectedRange.startDate),
                      end_date: formatDate(selectedRange.endDate),
                      status: status?.toUpperCase(),
                      vendor_id:
                        searchFilter === "vendor_id"
                          ? searchText
                          : selectedVendorOption?.id ?? undefined,
                      utr: searchFilter === "utr" ? searchText : null,
                    });
                  }}
                  selectedRange={selectedRange}
                  setSelectedRange={setSelectedRange}
                  setIsDateRangeIsSelected={setIsDateRangeIsSelected}
                />

                <div className="w-full ml-2">
                  <VendorDropdownSelect
                    setSelectSchool={setSelectSchool}
                    setSchoolId={setSchoolId}
                    selectedVendor={selectedVendorOption}
                    onVendorSelect={handleVendorSelect}
                  />
                </div>
              </div>
            </div>
            <div>
              <RowsPerPageSelect
                setItemsPerRow={(e: any) => {
                  setCurrentPage(1);
                  setItemsPerRow(e);
                  refetchDataFetch({
                    page: 1,
                    limit: e.name,
                    start_date: isDateRangeIsSelected
                      ? formatDate(selectedRange.startDate)
                      : startDate,
                    end_date: isDateRangeIsSelected
                      ? formatDate(selectedRange.endDate)
                      : endDate,
                    vendor_id:
                      searchFilter === "vendor_id"
                        ? searchText
                        : selectedVendorOption?.id ?? undefined,
                    utr: searchFilter === "utr" ? searchText : null,
                  });
                }}
                itemsPerRow={itemsPerRow}
                className=" justify-start"
              />
            </div>
            <div className="flex items-center">
              {/* {type !== "" && (
                  <div className=" text-sm m-2  max-w-fit ">
                    <button
                      onClick={async () => {
                        setSelectedRange({
                          startDate: new Date(),
                          endDate: new Date(),
                          key: "selection",
                        });
                        setType("");
                        setIsDateRangeIsSelected(false);
                        setCurrentPage(1);
                        refetchDataFetch({
                          page: 1,
                          limit: Number(itemsPerRow.name),
                          start_date: startDate,
                          end_date: endDate,
                          status: status?.toUpperCase(),
                          vendor_id:
                            searchFilter === "vendor_id"
                              ? searchText
                              : selectedVendorOption?.id ?? undefined,
                          utr: searchFilter === "utr" ? searchText : null,
                        });
                      }}
                      className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                    >
                      {type} <HiMiniXMark className=" text-lg ml-1" />
                    </button>
                  </div>
                )} */}
              {dateRange !== "" && (
                <div className=" text-sm m-2  max-w-fit ">
                  <button
                    onClick={async () => {
                      setSelectedRange({
                        startDate: new Date(),
                        endDate: new Date(),
                        key: "selection",
                      });
                      setDateRange("");
                      setIsDateRangeIsSelected(false);
                      setCurrentPage(1);
                      refetchDataFetch({
                        page: 1,
                        limit: Number(itemsPerRow.name),
                        start_date: startDate,
                        end_date: endDate,
                        status: status?.toUpperCase(),
                        vendor_id:
                          searchFilter === "vendor_id"
                            ? searchText
                            : selectedVendorOption?.id ?? undefined,
                        utr: searchFilter === "utr" ? searchText : null,
                      });

                    }}
                    className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                  >
                    {dateRange} <HiMiniXMark className=" text-lg ml-1" />
                  </button>
                </div>
              )}
              {selectSchool !== "" && (
                <div className=" text-sm m-2  max-w-fit ">
                  <button
                    onClick={() => {
                      setCurrentPage(1);
                      setSelectSchool("")
                      setSelectedVendorOption(null);
                      refetchDataFetch({
                        page: 1,
                        limit: Number(itemsPerRow.name),
                        start_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.startDate)
                          : startDate,
                        end_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.endDate)
                          : endDate,
                        status: status?.toUpperCase(),
                        vendor_id:
                          searchFilter === "vendor_id"
                            ? searchText
                            : selectedVendorOption?.id ?? undefined,
                        utr: searchFilter === "utr" ? searchText : null,
                      });
                    }}
                    className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                  >
                    {selectSchool} <HiMiniXMark className=" text-lg ml-1" />
                  </button>
                </div>
              )}
              {status && (
                <div className=" text-sm m-2  max-w-fit ">
                  <button
                    onClick={async () => {
                      setCurrentPage(1);
                      setStatus("");
                      refetchDataFetch({
                        page: 1,
                        limit: Number(itemsPerRow.name),
                        start_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.startDate)
                          : startDate,
                        end_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.endDate)
                          : endDate,
                        vendor_id:
                          searchFilter === "vendor_id"
                            ? searchText
                            : selectedVendorOption?.id ?? undefined,
                        utr: searchFilter === "utr" ? searchText : null,
                      });
                    }}
                    className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                  >
                    {status} <HiMiniXMark className=" text-lg ml-1" />
                  </button>
                </div>
              )}
            </div>
          </div>
        }
        data={[
          [
            "Sr.No",
            "Institute Name",
            "Vendor Name",
            "Settlement Amount",
            "Adjustment",
            "Payment Amount",
            "From",
            "Till",
            "Status",
            "UTR No",
            "Settlement Date",
          ],

          ...([
            ...settlementData.map((d: any, index: number) => {
              return {
                ...d,
                serialNumber:
                  (currentPage - 1) * itemsPerRow.name + 1 + index,
              };
            }),
          ].map((settlement: any) => [
            <div
              className="truncate cursor-pointer"
              onClick={() =>
                navigate("/payments/vendor-settlements-transaction", {
                  state: {
                    utrno: settlement?.utr,
                    settlementDate: settlement?.settled_on,
                    vendor_id: settlement?.vendor_id,
                    vendor_transaction_amount: settlement?.vendor_transaction_amount,
                    from: settlementReturnPath,
                  },
                })
              }
            >
              {settlement.serialNumber}
            </div>,

            <div
              className="truncate cursor-pointer"
              onClick={() =>
                navigate("/payments/vendor-settlements-transaction", {
                  state: {
                    utrno: settlement?.utr,
                    settlementDate: settlement?.settled_on,
                    vendor_id: settlement?.vendor_id,
                    vendor_transaction_amount: settlement?.vendor_transaction_amount,
                    from: settlementReturnPath,
                  },
                })
              }
            >
              {settlement?.school_name}
            </div>,

            <div className="truncate">{settlement?.vendor_name}</div>,
            <div className=" truncate">
              {amountFormat(settlement?.settlement_amount)}
            </div>,
            <div className=" truncate">{settlement?.adjustment}</div>,
            <div className=" truncate">
              {amountFormat(settlement?.net_settlement_amount)}
            </div>,

            <div className=" truncate">
              {new Date(settlement?.payment_from).toLocaleDateString(
                "en-US",
                {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                }
              )}
            </div>,
            <div className=" truncate">
              {new Date(settlement?.payment_till).toLocaleDateString(
                "en-US",
                {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                }
              )}
            </div>,
            <div
              className={
                " truncate " +
                (settlement.status.toLowerCase() === "settled" ||
                  settlement.status.toLowerCase() === "success"
                  ? "text-[#04B521]"
                  : "")
              }
            >
              {settlement.status.toLowerCase() === "settled" ||
                settlement.status.toLowerCase() === "success"
                ? "Settled"
                : settlement.status}
            </div>,
            <div
              className=" truncate overflow-hidden"
              style={{ maxWidth: "5em" }}
              title={settlement?.utr}
            >
              {settlement?.utr}
            </div>,
            <div className="truncate">
              {new Date(settlement?.settled_on).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </div>,
          ]) || []),
        ]}
        footer={
          <div className="flex justify-center items-center">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        }
      />
    </div>
  );
}

export default VendorSettlement;
